var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.202,
    cy: 21.965,
    r: 20.995,
    fill: "#3D60A2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#njxyaq3yma)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.972 22.729H15.43a.715.715 0 0 0-.715.715v10.015a.715.715 0 0 0 1.43 0v-.715h10.112v.715a.715.715 0 0 0 1.43 0V23.444a.715.715 0 0 0-.715-.715zm-10.826 1.43h10.11v4.293h-1.478v-2.147a.715.715 0 0 0-.715-.715H18.34a.715.715 0 0 0-.716.715v2.147h-1.478v-4.293zm5.77 4.293V27.02h1.431v1.43h-1.43zm-2.861 0V27.02h1.43v1.43h-1.43zm-2.91 1.43h10.112v1.431H16.146v-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.411 16.194a.715.715 0 0 0-.715-.715 10.82 10.82 0 0 1-8.805-4.367 3.354 3.354 0 0 0-2.69-1.356 3.354 3.354 0 0 0-2.688 1.356 10.82 10.82 0 0 1-8.805 4.367.715.715 0 0 0-.716.715V33.46a.715.715 0 0 0 1.431 0v-.715h2.146c.395 0 .716-.32.716-.715 0-2.986-1.271-4.725-2.227-5.61a7.47 7.47 0 0 0 1.302-1.039c.992-.992 2.159-2.733 2.333-5.513H27.71c.173 2.78 1.34 4.521 2.333 5.513.453.454.908.793 1.3 1.04-.954.884-2.225 2.623-2.225 5.608 0 .396.32.716.715.716h2.146v.715a.715.715 0 0 0 1.431 0V16.194zm-22.988 2.242V16.91H31.98v1.526H10.423zm9.241-6.475a1.892 1.892 0 0 1 1.538-.774c.614 0 1.174.282 1.537.774a12.328 12.328 0 0 0 4.072 3.518h-11.22a12.328 12.328 0 0 0 4.073-3.518zm-7.84 19.352h-1.401v-3.5c.595.677 1.254 1.792 1.4 3.5zm-.429-6.992a6.069 6.069 0 0 1-.972.805v-5.26h2.837c-.128 1.823-.753 3.319-1.865 4.455zm19.613 0c-1.111-1.136-1.737-2.632-1.864-4.454h2.836v5.26a6.063 6.063 0 0 1-.972-.806zm-.429 6.992c.11-1.31.545-2.525 1.401-3.495v3.495H30.58z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "njxyaq3yma"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8.992 9.756)",
    d: "M0 0h24.419v24.419H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVip);
export default __webpack_public_path__ + "static/media/vip.0f734ff809993767a1fa33dadd0d807e.svg";
export { ForwardRef as ReactComponent };